<template>
	<div
		class="wait-modal"
		:class="{'wait-modal--closed': closed}"
		role="dialog"
		aria-modal="true"
		:aria-labelledby="titleId"
		:aria-describedby="messageId"
	>
		<section class="wait-modal__content">
			<header class="wait-modal__header">
				<h2 :id="titleId">{{resolvedTitle}}</h2>
				<button type="button" :aria-label="translation.close" @click="close">&times;</button>
			</header>
			<div class="wait-modal__body">
				<span class="wait-modal__spinner" aria-hidden="true"></span>
				<p :id="messageId">{{message}}</p>
			</div>
		</section>
	</div>
</template>

<script>
import { translate } from '../../assets/translations';
export default {
	props: {
		title: {
			type: String,
			default: '',
		},
	},
	computed: {
    translation() {
		return translate(this.$store.state.language).waitModal;
	},
	resolvedTitle() {
		return this.customTitle || this.title || this.translation.title;
	},
	titleId() {
		return `${this._uid}-wait-modal-title`;
	},
	messageId() {
		return `${this._uid}-wait-modal-message`;
	},
  },
  data(){
		return{
			closed: true,
			customTitle: '',
			message: '',
		};
	},
	created() {
		this.message = this.translation.message;
	},
  methods:{
	open(personalizatedMessage = null, personalizatedTitle = null){
		this.message = personalizatedMessage || this.translation.message;
		this.customTitle = personalizatedTitle || '';
      this.closed = false;
    },
    close(){
      this.closed = true;
		this.customTitle = '';
    }
  }
}
</script>
<style scoped lang="scss">
.wait-modal--closed {
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
}

.wait-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 2000;
  inset: 0;
  box-sizing: border-box;
  padding: 9px;
  overflow: hidden;
  background: rgba(0, 0, 0, .55);
  opacity: 1;
  transition: visibility .2s, opacity .2s linear;
}

.wait-modal__content {
  width: 100%;
  max-width: 560px;
  overflow: hidden;
  border-radius: 13px;
  background: #ffffff;
  box-shadow: 0 18px 45px rgba(0, 0, 0, .25);
}

.wait-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 53px;
  padding: 0 11px 0 20px;
  background: #67adc6;
  color: #ffffff;
}

.wait-modal__header h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
}

.wait-modal__header button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #ffffff;
  font-size: 26px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
}

.wait-modal__header button:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: -4px;
}

.wait-modal__body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-height: 97px;
  box-sizing: border-box;
  padding: 19px 24px 22px;
  color: #4c4b4b;
}

.wait-modal__body p {
  margin: 8px 0 0;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
}

.wait-modal__spinner {
  width: 16px;
  height: 16px;
  box-sizing: border-box;
  border: 3px solid #d7d7d7;
  border-top-color: #002c41;
  border-radius: 50%;
  animation: wait-modal-spin .7s linear infinite;
}

@keyframes wait-modal-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .wait-modal__spinner {
    animation-duration: 1.4s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/WaitModal.vue